import {ModalBody} from 'src/components/modal-atoms/ModalAtoms'
import styled, {css} from 'styled-components'

export const StyledModalBody = styled(ModalBody)`
    ${({theme: {spacing}}) => css`
        padding: ${spacing * 6}px ${spacing * 6}px ${spacing * 4}px;
        gap: ${spacing * 7.5}px;
    `}
`

export const StyledTitle = styled.h3`
    ${({theme: {typography, colors}}) => css`
        ${typography.textMd};
        font-weight: 700;
        color: ${colors.lightBlack};
    `}
`

export const StyledFooter = styled.div`
    ${({theme: {spacing}}) => css`
        display: flex;
        justify-content: flex-end;
        gap: ${spacing * 2.5}px;
    `}
`
